module.exports = {
	"articleTitle1": "A little of the big city in A2",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Melange",
	"articleLink1": "https://www.michigandaily.com/content/little-big-city-a2",
	"articleLink2": "https://www.michigandaily.com/arts/03bside-secondary-dance-mix12",
	"articleSnippet1": "Nov 29, 2007 ... It seems like a dining experience typical of any large city, but Mélange Bistro and \nWine Bar is a few blocks away from Central Campus, ...",
	"articleSnippet2": "Mar 9, 2015 ... The sense of camaraderie in Dance Mix is what draws in so many guest \nperforming groups to apply each year. It takes the passion that the ...",
	"foodRecommendations": [],
	"articleTitle2": "Dance Mix a mélange of genres and styles on stage",
	"address": "312 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279019,
		"lng": -83.749017
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/melange.json
// module id = 918
// module chunks = 0